import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'delimiter',
    standalone: false
})
export class DelimiterPipe implements PipeTransform {
  transform(value: string, delimiter: string, isLast: boolean): string {
    return isLast ? value : `${value}${delimiter} `;
  }
}
